import type { Review } from '../types/content';

/**
 * Five review slots for the "Trusted by Leaders" carousel.
 *
 * Drafts are NEVER shown on the website. Until at least one review is
 * approved, visitors see a clean "Client feedback coming soon" panel.
 *
 * TO PUBLISH A GENUINE REVIEW, complete one draft:
 *   1. Fill in `name` (e.g. "John Anderson"), `title` (e.g. "Chief Executive
 *      Officer") and `quote` with the reviewer's approved details and wording.
 *      Add `company` only if they approved naming it.
 *   2. Optionally set `photoUrl` to a real photograph supplied by the reviewer,
 *      plus `photoAlt` (e.g. "Portrait of John Anderson").
 *   3. Change `status` from 'draft' to 'approved'.
 *   4. Set `verified: true` only after confirming identity and engagement.
 *
 * Anonymous reviewer: set `anonymous: true` and `anonymousDescriptor`
 * (e.g. "Chief Executive Officer, Global Services Firm"); omit `photoUrl`.
 *
 * Never use generated faces or invented testimonials.
 */
export const reviews: Review[] = [
  { id: 'review-1', rank: 1, status: 'draft', relationship: 'Client', verified: false, anonymous: false, name: '', title: '', quote: '' },
  { id: 'review-2', rank: 2, status: 'draft', relationship: 'Client', verified: false, anonymous: false, name: '', title: '', quote: '' },
  { id: 'review-3', rank: 3, status: 'draft', relationship: 'Client', verified: false, anonymous: false, name: '', title: '', quote: '' },
  { id: 'review-4', rank: 4, status: 'draft', relationship: 'Client', verified: false, anonymous: false, name: '', title: '', quote: '' },
  { id: 'review-5', rank: 5, status: 'draft', relationship: 'Client', verified: false, anonymous: false, name: '', title: '', quote: '' },
];
